var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 7.16602C10.6667 8.63877 9.47276 9.83268 8 9.83268C6.52724 9.83268 5.33333 8.63877 5.33333 7.16602C5.33333 5.69326 6.52724 4.49935 8 4.49935C9.47276 4.49935 10.6667 5.69326 10.6667 7.16602ZM9.33333 7.16602C9.33333 7.90239 8.73638 8.49935 8 8.49935C7.26362 8.49935 6.66667 7.90239 6.66667 7.16602C6.66667 6.42964 7.26362 5.83268 8 5.83268C8.73638 5.83268 9.33333 6.42964 9.33333 7.16602Z",
    fill: "#314071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15 13.3758C5.9 14.1203 6.65 14.7904 7.4 15.386C7.45771 15.4242 7.51542 15.4624 7.57187 15.5006C7.8336 15.6776 8.18118 15.6969 8.43263 15.5055C8.48497 15.4657 8.5398 15.4258 8.6 15.386C9.35 14.7904 10.175 14.1203 10.85 13.3758C12.8 11.2912 14 9.20662 14 7.12202C14 3.84622 11.3 1.16602 8 1.16602C4.7 1.16602 2 3.84622 2 7.12202C2 9.20662 3.2 11.2912 5.15 13.3758ZM9.87628 12.465L9.86919 12.4726L9.86221 12.4803C9.32991 13.0674 8.67525 13.6183 8.00109 14.1583C7.37397 13.6469 6.74251 13.0769 6.10695 12.447C4.24455 10.4514 3.33333 8.69028 3.33333 7.12202C3.33333 4.59183 5.42711 2.49935 8 2.49935C10.5729 2.49935 12.6667 4.59183 12.6667 7.12202C12.6667 8.69498 11.75 10.4619 9.87628 12.465Z",
    fill: "#314071"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsIcon);
export default __webpack_public_path__ + "static/media/gpsIcon.5fa3ea98a60772432343ade95384cbb3.svg";
export { ForwardRef as ReactComponent };